import { Pipe, PipeTransform } from '@angular/core';

import { MapUtilsService } from '../core/upgraded-providers';

@Pipe({
    name: 'roomRange'
})
export class RoomRangePipe implements PipeTransform {

    constructor(private _mapUtils: MapUtilsService) {
    }

    transform(sourceRoom: string, targetRoom: string, worldSize): string|number {
        if (!/^[WE]\d+[NS]\d+$/i.test(targetRoom)) {
            return '—';
        }

        const [x1, y1] = this._mapUtils.roomNameToXY(sourceRoom);
        const [x2, y2] = this._mapUtils.roomNameToXY(targetRoom);

        const dx = Math.abs(x2 - x1);
        const dy = Math.abs(y2 - y1);

        return Math.max(
            Math.min(worldSize.width - dx, dx),
            Math.min(worldSize.height - dy, dy)
        );
    }

}
